import FeedbackButton from "components/FeedbackButton";

const STACK_SETTINGS_HEADER_FEEDBACK_ID = "stack-settings--feedback-button";

const StackSettingsLeaveFeedbackButton = () => {
  return <FeedbackButton id={STACK_SETTINGS_HEADER_FEEDBACK_ID} />;
};

export default StackSettingsLeaveFeedbackButton;
